import { render, staticRenderFns } from "./ContinuousProduction.vue?vue&type=template&id=315faef2"
import script from "./ContinuousProduction.vue?vue&type=script&lang=js"
export * from "./ContinuousProduction.vue?vue&type=script&lang=js"
import style0 from "./ContinuousProduction.vue?vue&type=style&index=0&id=315faef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports